import React from 'react';

import {
  useBlockParent,
  useCurrentBlockElement,
  useCurrentBlockId,
  useDocumentBlockName,
} from '@wp-block-builder/editor/hooks';

import ColumnTuneMenu from './ColumnTuneMenu';
import SectionTuneMenu from './SectionTuneMenu';

export default function TuneMenu() {
  const [anchorEl] = useCurrentBlockElement();
  const currentBlockId = useCurrentBlockId();
  const parentBlock = useBlockParent(currentBlockId);
  const currentBlockName = useDocumentBlockName(currentBlockId);
  const parentBlockName = useDocumentBlockName(parentBlock?.id ?? null);

  if (currentBlockName === null || anchorEl === null) {
    return null;
  }
  if (parentBlock === null || parentBlockName === null || parentBlock.type !== 'ColumnsSection') {
    return <SectionTuneMenu name={currentBlockName} />;
  }
  return <ColumnTuneMenu name={currentBlockName} parentBlockName={parentBlockName} />;
}
